var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchangeTrailer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.5 20.1",
    style: {
      enableBackground: "new 0 0 26.5 20.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{fill:#3D66B0;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2.4,2.3 2.4,9.1 4.1,9.1 4.1,3.1 5.7,3.1 5.7,9.1 7.4,9.1 7.4,3.1 9.1,3.1 9.1,9.1 10.6,9.1 10.6,3.1  12.3,3.1 12.3,9.1 14,9.1 14,3.1 15.7,3.1 15.7,9.1 17.4,9.1 17.4,2.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.3,12.9H7c0.1-0.2,0.2-0.4,0.4-0.5H5.9C6.1,12.5,6.2,12.7,6.3,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.6,12.9h1.1c0.1-0.2,0.2-0.4,0.4-0.5H1.6V12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.8,12.8c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0.2-0.6,0.5-0.6,0.9c0,0.5,0.4,0.9,0.9,0.9 s0.9-0.4,0.9-0.9C5.4,13.3,5.1,12.9,4.8,12.8z M4.5,14.2c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4s0.4,0.1,0.4,0.3 C4.9,13.9,4.7,14.2,4.5,14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,13.7c0,0.5,0.4,0.8,0.8,0.9c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.1,0.1-0.2,0.1-0.3 c0-0.2,0-0.5,0-0.7c0,0,0,0,0,0C8,13,7.8,13.3,7.8,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.3,11.4h4.2c0-0.2,0.1-0.4,0.1-0.6H4.3V11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.4,2.3v6.8h1.7v-6h1.6v6h1.7v-6h1.7v6c0.4-0.9,0.9-1.7,1.5-2.4V3.1h1.7v2c0.5-0.4,1.1-0.7,1.7-0.9V3.1h1.7 v0.6c0.6-0.1,1.1-0.2,1.7-0.2V2.3H2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.6,3.1v3.6c0.5-0.6,1.1-1.1,1.7-1.5v-2H10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.8,13.7c0-0.4,0.2-0.7,0.6-0.9c0,0,0,0,0,0c0-0.1,0-0.1,0-0.2c0-0.4,0-0.8,0.1-1.2H4.3v-0.6h4.3 C8.7,10.2,8.9,9.6,9.1,9v-6H7.4v6H5.7v-6H4.1v6H2.4V2.3h15v1.2c0,0,0,0,0.1,0c0.6,0,1.1,0.1,1.6,0.2c0-1.7,0-3.1,0-3.1H0.7v10.2 h2.6v0.6H0.7v0.7v0.3v0.5V13v0.8h1.8c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2h0.3c0,1.1,0.9,2,2,2c0.1,0,0.1,0,0.2,0 c-0.1-0.4-0.3-0.8-0.4-1.2C8.2,14.5,7.8,14.1,7.8,13.7z M2.7,12.9H1.6v-0.5h1.5C2.9,12.5,2.8,12.7,2.7,12.9z M4.5,14.6 c-0.5,0-0.9-0.4-0.9-0.9c0-0.4,0.2-0.7,0.6-0.9c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.3,0.1,0.6,0.5,0.6,0.9 C5.4,14.2,5,14.6,4.5,14.6z M7,12.9H6.3c-0.1-0.2-0.2-0.4-0.4-0.5h1.5C7.2,12.5,7.1,12.7,7,12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14,3.1v1.1c0.5-0.2,1.1-0.4,1.7-0.5V3.1H14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.5,13.4c-0.2,0-0.4,0.2-0.4,0.4s0.2,0.4,0.4,0.4s0.4-0.3,0.4-0.5C4.9,13.5,4.7,13.4,4.5,13.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.3,13.8c0,0.1,0.1,0.3,0.2,0.4c0-0.2-0.1-0.4-0.1-0.6C8.4,13.5,8.3,13.6,8.3,13.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.9,19.5c-1.5-0.2-2.9-0.9-4-1.9c-1.1-1.1-1.8-2.6-2-4.2l0-0.2l-0.8,0c-0.4,0-0.8,0-0.8,0 c0,0,0.6-0.7,1.3-1.5s1.4-1.5,1.4-1.5c0,0,3,2.7,3,2.7c0,0-1.4,0.1-1.6,0.1h-0.1l0,0.2c0.1,1,0.5,1.9,1.3,2.7 c0.9,0.9,1.9,1.3,3.1,1.3c1.2,0,2.3-0.4,3.1-1.3c0.3-0.2,0.3-0.3,0.3-0.3c0,0,0.4,0.4,0.9,0.7c0.7,0.6,0.9,0.7,0.8,0.8 c0,0-0.2,0.2-0.3,0.4c-0.6,0.6-1.1,1-1.8,1.3c-0.7,0.3-1.3,0.5-2,0.7C18.3,19.5,17.3,19.6,16.9,19.5L16.9,19.5z M21.8,13.5 l-1.5-1.3l0.5,0c0.3,0,0.7,0,0.8,0l0.3,0l0-0.2c-0.1-1.1-0.6-2.1-1.4-2.8c-0.6-0.5-1.3-0.9-2-1.1c-0.9-0.2-1.9-0.1-2.7,0.2 c-0.5,0.2-1,0.5-1.4,0.9c-0.2,0.2-0.3,0.3-0.3,0.3c0,0-0.4-0.3-0.9-0.7L12.4,8l0-0.1c0,0,0.2-0.2,0.3-0.3c1-1.1,2.4-1.8,3.9-2 c0.4-0.1,1.4-0.1,1.9,0c2,0.3,3.7,1.4,4.8,3.1c0.5,0.8,0.9,1.9,1,2.9c0,0.2,0,0.4,0,0.4c0,0,0.4,0,0.8,0c0.5,0,0.8,0,0.8,0 c0,0-2.7,3-2.7,3C23.3,14.9,22.6,14.3,21.8,13.5L21.8,13.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchangeTrailer);
export default __webpack_public_path__ + "static/media/exchange-trailer.0bcf442bfa9f725fcf44e1870e62e397.svg";
export { ForwardRef as ReactComponent };